import React from 'react';
import { ActivityIndicator, FlatList, StyleSheet, Text } from 'react-native';
import { connect } from 'react-redux';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { IOpenInviteModel } from '../reducers';
import PartnerCard from './PartnerCard';

interface IProps {
  workoutId: string;
  amountJoiningClass: number;
  openInviteClass?: IOpenInviteModel;
  hideHeading: boolean;
  t(key: string): string;
}

const List = ({
  t,
  openInviteClass,
  hideHeading = false,
}: IProps) => openInviteClass ? (
    <FlatList
      data={openInviteClass.openInviteUserProfiles}
      showsVerticalScrollIndicator={false}
      keyExtractor={(item) => item.uid}
      contentContainerStyle={{ overflow: 'hidden' }}
      ListHeaderComponent={!hideHeading ? <ListHeader t={t} /> : <></>}
      ListFooterComponent={<ListFooter isLoading={openInviteClass.isLoadingClassList} />}
      renderItem={({ item }) => item && (
        <PartnerCard
          t={t}
          key={item.uid}
          partner={item}
          renderInviteStatus={false}
          isLoading={openInviteClass.isLoadingClassList}
          containerStyle={{
            borderTopWidth: 0,
            paddingHorizontal: 0,
            paddingTop: 0,
          }}
        />
      )}
    />
  ) : null;

const ListHeader = ({t}) => (
  <Text style={[Theme.textStyle.heading2, {marginBottom: defaultScale(32)}]}>{t('joiningThisClass')}</Text>
);

const ListFooter = ({ isLoading }) => isLoading && (
  <ActivityIndicator
    animating={isLoading}
    color={Theme.PRIMARY}
  />
);

const styles = StyleSheet.create({
  classCount: {
    fontSize: 15,
    color: Theme.GREY_DARK_MEDIUM,
    fontFamily: Theme.Custom400,
  },
});

const mapStateToProps = (state, ownProps) => {
  const { openInviteClassesByWorkoutId } = state.bookings.bookings;
  const openInviteClass = openInviteClassesByWorkoutId[ownProps.workoutId];
  return { openInviteClass };
};

export const OpenClassList = connect(mapStateToProps)(List);
